/* global gdAlertify */
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axiosInstance from "../../config/axiosConfig"; // Asegúrate de tener tu configuración de axios
import BuscarPaciente from "../components/BuscarPaciente"; // Asegúrate de importar correctamente el componente BuscarPaciente

const FormIngresoEnfermeria = () => {
    const { id } = useParams();
    const [datosPaciente, setDatosPaciente] = useState({
        nombres: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        direccion: "",
        diagnostico: "",
        tipoTurno: "",
        des_turno: "",
        id: ""
    });

    const [datosRegistro, setDatosRegistro] = useState({
        id: 0,
        estadoSalud: "",
        estadoCognitivo: "",
        capacidadHablar: "",
        capacidadMoverse: "",
        necesidadesEspeciales: "",
        observacionesPaciente: "",
        estadoCama: "",
        accesos: "",
        estadoCasa: "",
        riesgos: "",
        asistenciaAdicional: "",
        antecedentesMedicos: "",
        examenFisico: "",
        medicamentos: "",
        rutinas: "",
        planAtencion: "",
        evaluacionDomicilio: "",
        observacionesSugerencias: "",
    });

    useEffect(() => {
        if (id && id != undefined) {
            fetchEnfermeria(id);
        }
    }, [id]);

    const fetchEnfermeria = async (visitaId) => {
        try {
            gdAlertify.showLoader();
            const { data } = await axiosInstance.post(`/paciente/ver-registro-enfermeria`,
                {visitaID:visitaId}
            );

            const visita = data.data;
            console.log(data);
            setDatosRegistro({
                id: (id && id != undefined) ? visita.id || 0 : 0,
                visitaID: (id && id != undefined) ? visita.visitaID || 0 : 0,
                estadoSalud: visita.estadoSalud || "",
                estadoCognitivo: visita.estadoCognitivo || "",
                capacidadHablar: visita.capacidadHablar || "",
                capacidadMoverse: visita.capacidadMoverse || "",
                necesidadesEspeciales: visita.necesidadesEspeciales || "",
                observacionesPaciente: visita.observacionesPaciente || "",
                estadoCama: visita.estadoCama || "",
                accesos: visita.accesos || "",
                estadoCasa: visita.estadoCasa || "",
                riesgos: visita.riesgos || "",
                asistenciaAdicional: visita.asistenciaAdicional || "",
                antecedentesMedicos: visita.antecedentesMedicos || "",
                examenFisico: visita.examenFisico || "",
                medicamentos: visita.medicamentos || "",
                rutinas: visita.rutinas || "",
                planAtencion: visita.planAtencion || "",
                evaluacionDomicilio: visita.evaluacionDomicilio || "",
                observacionesSugerencias: visita.observacionesSugerencias || "",
            });

            // Para mostrar paciente y auxiliares si están incluidos
            if (visita.paciente) {
                setDatosPaciente(visita.paciente);
            }

        } catch (error) {
            gdAlertify.alertError("Error al cargar la visita.");
        } finally {
            gdAlertify.hideLoader();
        }
    };

    const resetForm = () => {
        if (id && id != undefined) {
            return false;
        }

        setDatosPaciente({
            nombres: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            direccion: "",
            diagnostico: "",
            tipoTurno: "",
            des_turno: "",
            id: ""
        });

        setDatosRegistro({
            estadoSalud: "",
            estadoCognitivo: "",
            capacidadHablar: "",
            capacidadMoverse: "",
            necesidadesEspeciales: "",
            observacionesPaciente: "",
            estadoCama: "",
            accesos: "",
            estadoCasa: "",
            riesgos: "",
            asistenciaAdicional: "",
            antecedentesMedicos: "",
            examenFisico: "",
            medicamentos: "",
            rutinas: "",
            planAtencion: "",
            evaluacionDomicilio: "",
            observacionesSugerencias: "",
        });
    };

    // Seleccionar un paciente y prellenar los datos
    const seleccionarPaciente = (paciente) => {
        setDatosPaciente({
            nombres: paciente.nombres,
            apellidoPaterno: paciente.apellidoPaterno,
            apellidoMaterno: paciente.apellidoMaterno,
            direccion: paciente.direccion,
            diagnostico: paciente.diagnostico,
            tipoTurno: paciente.tipoTurno,
            id: paciente.id,
            des_turno: paciente.des_turno
        });

        if (paciente.enfermeria.length > 0) {
            let enfermeria = paciente.enfermeria[0];
            setDatosRegistro({
                estadoSalud: enfermeria.estadoSalud,
                estadoCognitivo: enfermeria.estadoCognitivo,
                capacidadHablar: enfermeria.capacidadHablar,
                capacidadMoverse: enfermeria.capacidadMoverse,
                necesidadesEspeciales: enfermeria.necesidadesEspeciales,
                observacionesPaciente: enfermeria.observacionesPaciente,
                estadoCama: enfermeria.estadoCama,
                accesos: enfermeria.accesos,
                estadoCasa: enfermeria.estadoCasa,
                riesgos: enfermeria.riesgos,
                asistenciaAdicional: enfermeria.asistenciaAdicional,
                antecedentesMedicos: enfermeria.antecedentesMedicos,
                examenFisico: enfermeria.examenFisico,
                medicamentos: enfermeria.medicamentos,
                rutinas: enfermeria.rutinas,
                planAtencion: enfermeria.planAtencion,
                evaluacionDomicilio: enfermeria.evaluacionDomicilio,
                observacionesSugerencias: enfermeria.observacionesSugerencias,
            });
        }
    };

    // Manejo del cambio en los inputs
    const handleChangeRegistro = (e) => {
        const { name, value } = e.target;
        setDatosRegistro({ ...datosRegistro, [name]: value });
    };

    // Enviar formulario
    const handleSubmit = async (e) => {
        e.preventDefault();
        gdAlertify.confirm({
            title: 'Registrar ingreso enfermeria',
            message: '¿Está seguro de registrar ingreso enfermeria?',
            onConfirm: async () => {
                gdAlertify.showLoader()
                try {
                    const response = await axiosInstance.post("/paciente/registro-enfermeria", {
                        datosPaciente,
                        datosRegistro,
                    });

                    if (!response.data.error) {
                        gdAlertify.alertSuccess(response.data.message);
                        resetForm();
                    } else {
                        gdAlertify.notiError(response.data.message);
                    }
                    gdAlertify.hideLoader()
                } catch (error) {
                    gdAlertify.hideLoader()
                    console.error("Error al registrar", error);
                    gdAlertify.notiError("Ocurrió un error al conectar con el servidor.");
                }
            },
            onCancel: () => {
                gdAlertify.notify('Envío cancelado', 'error');
            }
        });
    };

    return (
        <div className="container mt-5">
            <div className="card shadow">
                <div className="card-body">
                    <fieldset className="border p-3 mb-3">
                        <legend className="w-auto">Ingreso de Enfermería</legend>
                        {/* Buscador de pacientes */}
                        <BuscarPaciente
                            onSelect={seleccionarPaciente}
                            conEnfermeria={true}
                        />

                        {/* Datos del Paciente */}
                        <fieldset className="border p-3 mb-3">
                            <legend className="w-auto">Datos Paciente</legend>
                            <div className="row">
                                {[
                                    { name: "nombres", label: "Nombres" },
                                    { name: "apellidoPaterno", label: "Apellido Paterno" },
                                    { name: "apellidoMaterno", label: "Apellido Materno" },
                                    { name: "direccion", label: "Dirección" },
                                    { name: "diagnostico", label: "Diagnóstico o Patología" },
                                    { name: "des_turno", label: "Tipo de Turno" },
                                ].map((field) => (
                                    <div className="col-md-6 mb-3" key={field.name}>
                                        <label className="form-label">{field.label}</label>
                                        <div className="form-control-plaintext">
                                            {datosPaciente[field.name] || "No disponible"}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </fieldset>

                        {/* Registrar Infraestructura */}
                        <fieldset className="border p-3 mb-3">
                            <legend className="w-auto">Registrar Infraestructura</legend>
                            <div className="row">
                                {[
                                    { name: "estadoCama", label: "Estado de Cama" },
                                    { name: "accesos", label: "Accesos" },
                                    { name: "estadoCasa", label: "Estado de la Casa" },
                                    { name: "riesgos", label: "Riesgos" },
                                    { name: "asistenciaAdicional", label: "Asistencias Adicionales" },
                                ].map((field) => (
                                    <div className="col-md-6 mb-3" key={field.name}>
                                        <label className="form-label">{field.label}</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name={field.name}
                                            value={datosRegistro[field.name]}
                                            onChange={handleChangeRegistro}
                                        />
                                    </div>
                                ))}
                            </div>
                        </fieldset>

                        {/* Registrar Paciente - Campos de la imagen */}
                        <fieldset className="border p-3 mb-3">
                            <legend className="w-auto">Registrar Paciente</legend>
                            <div className="row">
                                {[
                                    { name: "estadoSalud", label: "Estado de Salud" },
                                    { name: "estadoCognitivo", label: "Estado Cognitivo" },
                                    { name: "capacidadHablar", label: "Lenguaje" },
                                    { name: "capacidadMoverse", label: "Movilidad" },
                                    { name: "necesidadesEspeciales", label: "Necesidades Especiales" },
                                    { name: "observacionesPaciente", label: "Observaciones" },
                                ].map((field) => (
                                    <div className="col-md-6 mb-3" key={field.name}>
                                        <label className="form-label">{field.label}</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name={field.name}
                                            value={datosRegistro[field.name]}
                                            onChange={handleChangeRegistro}
                                        />
                                    </div>
                                ))}
                            </div>
                        </fieldset>

                        {/* Resto del Registro */}
                        <fieldset className="border p-3 mb-3">
                            <legend className="w-auto">Detalles Adicionales</legend>
                            {[
                                { name: "antecedentesMedicos", label: "Antecedentes Médicos" },
                                { name: "examenFisico", label: "Evolución" },
                                { name: "medicamentos", label: "Medicamentos Horarios y Dosis" },
                                { name: "rutinas", label: "Rutinas y/o Actividades del Paciente" },
                                { name: "planAtencion", label: "Plan de Atención" },
                                { name: "evaluacionDomicilio", label: "Evaluación del Domicilio" },
                                { name: "observacionesSugerencias", label: "Observaciones y/o Sugerencias" },
                            ].map((field) => (
                                <div className="mb-3" key={field.name}>
                                    <label className="form-label">{field.label}</label>
                                    <textarea
                                        className="form-control"
                                        name={field.name}
                                        rows="2"
                                        value={datosRegistro[field.name]}
                                        onChange={handleChangeRegistro}
                                    ></textarea>
                                </div>
                            ))}
                        </fieldset>

                        <div className="d-grid">
                            <button className="btn btn-primary" onClick={handleSubmit}>Guardar</button>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
    );
};

export default FormIngresoEnfermeria;
